/** Devuelve si la respuesta de un pedido todavía corresponde al último iniciado. */
export type IsLatestRequest = () => boolean;

export interface LatestRequestTracker {
  /** Marca el inicio de un pedido nuevo; los anteriores dejan de estar vigentes. */
  start(): IsLatestRequest;
}

/**
 * Descarta respuestas tardías: si el usuario cambia de rango o de evento antes de
 * que llegue la respuesta anterior, esa respuesta no pisa el dato nuevo ni apaga
 * el skeleton del pedido que sigue en curso.
 */
export function latestRequestTracker(): LatestRequestTracker {
  let latest = 0;
  return {
    start(): IsLatestRequest {
      const id = ++latest;
      return () => id === latest;
    },
  };
}
